import React, {useState,useEffect,useCallback} from 'react';
import {RouteComponentProps, Redirect, Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
//import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import TagIcon from '@mui/icons-material/LocalOffer';
import LaunchIcon from '@mui/icons-material/Launch';
import MessageIcon from '@mui/icons-material/Assignment';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Close';
import ShopIcon from '@mui/icons-material/Shop';
import CopyToClipboard from 'react-copy-to-clipboard';
import {Inc,Owner,Item,Dataset,EventTag} from './Inc';
import Ajax from './Ajax';
import BottomButtons from './BottomButtons';
import ItemInput from './ItemInput';
import MultiLines from './MultiLines';
import ColData from './ColData';
import RowData from './RowData';
import StoreImg from './StoreImg';
import Loading from './Loading';
import Title from './Title';
import Toast from './Toast';
import HelpPop from './HelpPop';
import {Tools} from './Tools';

interface ItemDetailProps {
    owner:Owner,
	managerId:number,
}

interface RCProps extends RouteComponentProps<{id:string}> {

}

interface Params {
	links:Dataset[],
	specs:Dataset[],
	photo_ids:number[],
	gift_ids:number[],
	tags:string[],
	guides:Dataset[],
	//event_tags:EventTag[],
}

//let isLoading:boolean = true;
//let itemId = 0;

const ItemDetail = (props:ItemDetailProps)=> {
    Ajax.setEditorId(props.owner.owner_id);

	const rcp:RCProps = useReactRouter();
    const classes = useStyles();
    const defParams:Params = {
        links:[],
        specs:[],
        photo_ids:[],
		gift_ids:[],
		tags:[],
		guides:[],
		//event_tags:[],
    }
    const [states,setStates] = useState({
        item: Inc.defaultItem(),
        params: defParams,
		advanced: [false,false,false],
        notFound: false,
		isInput: false,
		isLoading: true,
    });
	const [toast,setToast] = useState('');
    const load = useCallback(()=>{
        if( !rcp.match.params.id ){
			return;
		}
        const itemId = parseInt(rcp.match.params.id);
		setStates(prev=>({...prev,isLoading:true}));
		Ajax.send("item/get",{item_id:itemId,event_tag:'selected'},(res:any)=>{
            if( res.ok ){
                setStates(prev=>({...prev,item:Inc.convItem(res.item),params:res.params,advanced:res.advanced,notFound:false,isInput:false,isLoading:false}));
            } else {
                setStates(prev=>({...prev,notFound:true}));
            }
        });
    },[rcp.match.params.id]);
    const getPreviewUrl = (item:Item)=>{
        //let url = "https://store.retro-biz.com/?mod=item&act=preview&item_id=" + String(item_id);
        let url = process.env.REACT_APP_DEPARTURL + "/items/"+item.item_id;
        if( item.preview_key ){
            url = url + "?sbpv=1";
        }
        return url;
    }
    const getStoreUrl = (item:Item)=>{
		let url = process.env.REACT_APP_DEPARTURL + "/items/" + item.item_id;
        return url;
    }
    const getCategoryUrl = (item:Item)=>{
		let url = process.env.REACT_APP_DEPARTURL + "/items/search/ct"+ item.cat_type_id + "/c" + item.cat_id;
        return url;
    }
	const copy = ()=>{
		setToast('クリップボードにURLをコピーしました');
	}
	const closeToast = ()=>{
		setToast('');
	}
	const openInput = ()=>{
		setStates({...states,isInput:true});
	}
	const closeInput = (updated:boolean,itemId:number)=>{
		if( updated ){
			load();
		} else {
			setStates({...states,isInput:false});
		}
	}
	const dummy = ()=>{

	}
	useEffect( ()=>{
		load();
		window.scroll(0,0);
	},[load]);

	if( states.notFound ){
		if( props.owner.owner_id===0 ){
			return (
				<Redirect to="/profile"/>
			);
		} else {
			return (
				<Redirect to="/"/>
			);
		}
	}

	let tax_inc = "税込";
	if( states.item.tax_inc==="0" ){
		tax_inc = "税抜";
	}
	const price = tax_inc+" "+Tools.comma(states.item.price)+"円";
	let upto = "制限なし";
	if( states.item.upto>0 ){
		upto = String(states.item.upto)+states.item.unit;
	}

	const toCategory = getCategoryUrl(states.item);
	const toPreview = getPreviewUrl(states.item);
	const toStore = getStoreUrl(states.item);
	//const toStore = 'https://store.retro-biz.com/i4865.html';
	let isSecret = false;
	if( states.item.status==="0" ){
		isSecret = true;
	}

	return (
		<div className={classes.root}>
			<Grid container spacing={2}>
				<Grid item xs={12} md={9}>
					<Paper className={classes.paper}>
						<Title text="商品詳細（本・雑貨）" icon="cart"/>
						<div style={{marginBottom:"1em"}}>
							<div>この商品の登録内容は以下の通りです。登録内容は販売中でも自由に変更できます。</div>
							{isSecret ? (
							<div>実際のストアでどのように表示されるかを見たい場合は、「プレビューする」を押して下さい。</div>
							):(
							<div>実際のストアの販売ページを見たい場合は、「販売ページ」を押して下さい。</div>
							)}
						</div>

						<Hidden mdUp implementation="js">
							{isSecret ? (
							<BottomButtons button1='編集する' onClick1={openInput} button2='一覧にもどる' link2='/item' button3='プレビュー' icon3={<ShopIcon/>} href3={toPreview}/>
							):(
							<BottomButtons button1='編集する' onClick1={openInput} button2='一覧にもどる' link2='/item' button3='販売ページ' icon3={<ShopIcon/>} href3={toStore}/>
							)}
						</Hidden>


						<Divider style={{marginBottom:"1em"}}/>
						<Grid container spacing={1}>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart0">
										<span>基本情報 01</span>
									</div>
									メイン画像
								</div>
							</Grid>
							{states.item.img_id>0 ? (
							<Grid item xs={12} sm={9} md={8}>
								<div style={{textAlign:"center",marginBottom:'0.1em'}}>
									<StoreImg
										owner_id={props.owner.owner_id}
										img_id={states.item.img_id}
										thumb={false}
										className="imgItemLarge"
									/>
								</div>
							</Grid>
							):(
							<Grid item xs={12} sm={9} md={8}><span className='emptyText'>なし</span></Grid>
							)}
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart0">
										<span>基本情報 02</span>
									</div>
									商品名
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.item.item_name}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart0">
										<span>基本情報 03</span>
									</div>
									商品の紹介文
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.params.guides.map((guide:Dataset,index:number)=>{
									const key = "guide"+index;
									return (
										<div key={key}>
										{guide.id!=='' &&
											<h3 style={{fontSize:'120%',color:'#000000'}}>{guide.id}</h3>
										}
										{guide.label!=='' &&
											<div style={{margin:'0',padding:'0',marginBottom:'3em',color:'#222222'}}><MultiLines text={guide.label}/></div>
										}
										</div>
									)
								})}
								{states.item.item_guide==='' &&
								<span className='emptyText'>なし</span>
								}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart0">
										<span>基本情報 04</span>
									</div>
									ショートコピー
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.item.promo_text==='' ? (
								<span className='emptyText'>なし</span>
								) : (
								<span>{states.item.promo_text}</span>
								)}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart0">
										<span>基本情報 05</span>
									</div>
									サンキューメッセージ
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.item.thankyou==='' ? (
								<span className='emptyText'>なし</span>
								) : (
								<span>{states.item.thankyou}</span>
								)}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart0">
										<span>基本情報 06</span>
									</div>
									単位
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.item.unit}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart0">
										<span>基本情報 07</span>
									</div>
									価格
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{price}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>


							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart0">
										<span>基本情報 08</span>
									</div>
									完売後の扱い
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.item.soldout}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart0">
										<span>基本情報 09</span>
									</div>
									完売後にキャンセルされた時の扱い
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.item.cancel}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							{states.advanced[0]===true &&
							<>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart1">
										<span>詳細情報 01</span>
									</div>
									仕様（サイズ・素材・製法など）
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.params.specs.map((data:Dataset,index:number)=>{
									const key = "data"+index;
									return (
										<ColData key={key} name={data.id} value={data.label} bgcolor={false}/>
									)
								})}
								{states.params.specs.length===0 &&
								<span className='emptyText'>なし</span>
								}

							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart1">
										<span>詳細情報 02</span>
									</div>
									関連リンク
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.params.links.map((data:Dataset,index:number)=>{
									const key = "data"+index;
									return (
										<ColData key={key} name={data.id} value={data.label} bgcolor={false}/>
									)
								})}
								{states.params.links.length===0 &&
								<span className='emptyText'>なし</span>
								}

							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart1">
										<span>詳細情報 03</span>
									</div>
									シリーズ
								</div>
							</Grid>
							{states.item.page_id>0 ? (
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.item.page_name}
							</Grid>
							):(
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								<span className='emptyText'>なし</span>
							</Grid>
							)}
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart1">
										<span>詳細情報 04</span>
									</div>
									販売数の制限
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{upto}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart1">
										<span>詳細情報 05</span>
									</div>
									検索キーワード
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								<MultiLines text={states.item.words} empty={true}/>
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart1">
										<span>詳細情報 06</span>
									</div>
									チャリティ
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.item.charity}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>
							</>}

							{states.advanced[1]===true &&
							<>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart2">
										<span>ファイル・画像 01</span>
									</div>
									ギャラリー
								</div>
							</Grid>
							{states.params.photo_ids.length>0 ? (
							<Grid item xs={12} sm={9} md={8}>
								<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
							{states.params.photo_ids.map((img_id:number,index:number)=>{
								const key = "photo"+index;
								return (
									<div key={key} style={{ flex: '0 0 auto' }}>
										<StoreImg
											owner_id={props.owner.owner_id}
											img_id={img_id}
											thumb={true}
											className="imgItemPhoto"
										/>
									</div>
								);
							})}
								</div>
							</Grid>
							):(
							<Grid item xs={12} sm={9} md={8}><span className='emptyText'>なし</span></Grid>
							)}
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart2">
										<span>ファイル・画像 02</span>
									</div>
									購入特典
								</div>
							</Grid>
							{states.params.gift_ids.length>0 ? (
							<Grid item xs={12} sm={9} md={8}>
								<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
								{states.params.gift_ids.map((img_id: number, index: number) => {
									const key = "gift" + index;
									return (
									<div key={key} style={{ flex: '0 0 auto' }}>
										<StoreImg
											owner_id={props.owner.owner_id}
											img_id={img_id}
											secret={states.item.gift_secret}
											thumb={true}
											className="imgItemPhoto"
										/>
									</div>
									);
								})}
								</div>
							</Grid>
							):(
							<Grid item xs={12} sm={9} md={8}><span className='emptyText'>なし</span></Grid>
							)}
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>
							</>}

							{states.advanced[2]===true &&
							<>
							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart3">
										<span>文芸・イベント 01</span>
									</div>
									レイティング
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.item.rating}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart3">
										<span>文芸・イベント 02</span>
									</div>
									文芸タグ
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{Inc.literatureTags.map((tag:Dataset,index:number)=>{
									if( states.params.tags.indexOf(tag.id)>=0 ){
										const key = "key"+index;
										return (
											<Chip key={key} icon={<TagIcon />} label={tag.label} variant="outlined"/>
										);
									} else {
										return (null);
									}
								})}
								{states.params.tags.length===0 &&
								<span className='emptyText'>なし</span>
								}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>

							{/*<Grid item xs={12} sm={3} md={4}>
								<div className={classes.itemDetailLabel}>
									<div className="itemPart3">
										<span>文芸・イベント 03</span>
									</div>
									イベントタグ
								</div>
							</Grid>
							<Grid item xs={12} sm={9} md={8} className="itemDetailValue">
								{states.params.event_tags.map((tag:EventTag,index:number)=>{
									const key = "key"+index;
									return (
										<Chip key={key} icon={<TagIcon />} label={tag.name} variant="outlined"/>
									);
								})}
								{states.params.event_tags.length===0 &&
								<span className='emptyText'>なし</span>
								}
							</Grid>
							<Grid item xs={12}>
								<Divider className={classes.formValidator}/>
							</Grid>*/}
							</>}
						</Grid>
					</Paper>
				</Grid>
				<Grid item xs={12} md={3}>
					<Paper className={classes.paper}>
						<Title text="管理情報" size={2}/>
						<RowData name="商品ID" value={String(states.item.item_id)}/>
						<RowData name="在庫" value={String(states.item.num_stock)+states.item.unit}/>
						<RowData name="前回販売" value={states.item.new_date}/>
						<div style={{position:"relative"}}>
							<div style={{position:"absolute",top:"0",left:"0",width:"40%"}}>状態</div>
							<div style={{marginLeft:"40%",textAlign:"right"}} className={classes.primary}>
								{Tools.colorLabel("item_status",states.item.status,states.item.status_label)}
							</div>
						</div>
						<Divider style={{marginTop:'1em',marginBottom:'0.5em'}}/>
						<div>
							<div>カテゴリ<HelpPop text='カテゴリは納品手続の際に架空ストアが設定します。カテゴリを変更したい場合は架空ストアまでご一報ください。'/></div>
							{(states.item.admit_flag==='1' && states.item.cats) ? (
							<div className={classes.primary}>
								<div style={{textAlign:"left",marginLeft:'-0.75em'}}>
									<a href={toCategory} rel="noopener noreferrer" target="_blank"><Button variant="text" color="primary"><LaunchIcon/> {states.item.cats[0]} → {states.item.cats[1]}</Button></a>
								</div>
							</div>
							):(
							<div className={classes.primary}>
								不明
							</div>
							)}
						</div>
						<Divider style={{marginTop:'0.5em',marginBottom:'0.5em'}}/>
						<div>
							<div>配送方法<HelpPop text={(<span>配送方法は架空ストアが商品のサイズや強度を確認した上で設定します。<br/>疑問がある場合は架空ストアまでご一報ください。</span>)}/></div>
							<div style={{marginTop:'0.25em'}} className={classes.primary}>
							{states.item.admit_flag==='1' ? (
							<div className={classes.primary}>
								{states.item.upack_flag==='1' ? (
									<>
									<Chip icon={<CheckIcon style={{color:'green'}}/>} label="ゆうパック" variant="outlined"/>
									<Chip icon={<CancelIcon style={{color:'red'}} />} label="ゆうパケット不可" />
									</>
								):(
									<>
									<Chip icon={<CheckIcon style={{color:'green'}}/>} label="ゆうパック" variant="outlined"/>
									<Chip icon={<CheckIcon style={{color:'green'}} />} label="ゆうパケット" variant="outlined"/>									
									</>
								)}
							</div>
							):(
							<div className={classes.primary}>
								不明
							</div>
							)}
							</div>
						</div>
						<Divider style={{marginTop:'0.5em',marginBottom:'0.5em'}}/>
						<div>
							<div>販売ページのURL</div>
							<div style={{lineHeight:"1.0em",textAlign:"left",marginBottom:'0.5em'}}>
								<input type="text" value={toStore} style={{width:'100%',padding:'0.25em 0.1em',boxSizing:'border-box'}} onChange={dummy}/>
							</div>
							<div style={{textAlign:"left",marginLeft:'-0.35em'}}>
								<a href={toStore} rel="noopener noreferrer" target="_blank"><Button variant="text" size="small" color="primary" startIcon={<LaunchIcon/>}>販売ページを開く</Button></a>
							<CopyToClipboard text={toStore} onCopy={copy}>
								<Button variant="text" color="primary" size="small" startIcon={<MessageIcon/>}>URLをコピー</Button>
							</CopyToClipboard>
							</div>
						</div>


						
						<Hidden mdDown implementation="js">
							<Divider style={{margin:"1em 0",marginTop:'0.5em'}}/>
							<Grid container spacing={1}>
								<Grid item xs={12} lg={12}>
									<Button variant="contained" color="primary" style={{width:"100%"}} onClick={openInput}>編集する</Button>
								</Grid>
								{isSecret &&
								<Grid item xs={12} lg={12}>
									<a href={toPreview} rel="noopener noreferrer" target="_blank"><Button variant="outlined" color="primary" style={{width:"100%"}}>プレビューする</Button></a>
								</Grid>
								}
								<Grid item xs={12} lg={12}>
									<Link to="/item"><Button variant="outlined" style={{width:"100%"}}>一覧にもどる</Button></Link>
								</Grid>
							</Grid>
						</Hidden>
					</Paper>
				</Grid>
			</Grid>
			<ItemInput itemId={states.item.item_id} managerId={props.managerId} isOpen={states.isInput} owner={props.owner} close={closeInput}/>
			<Loading isLoading={states.isLoading}/>
			<Toast mes={toast} close={closeToast}/>
		</div>
	);
}

export default ItemDetail;
